import useRewardsData, { RewardEvents } from 'components/CateringProvider/use-rewards-data';
import React, { useState, useEffect, useMemo } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import Icon from 'components/Icon';
import useIsDesktop from 'hooks/useIsDesktop';

function Title({ title }) {
  const [index, setIndex] = useState(true);
  const isDesktop = useIsDesktop();
  const maxRewardRate = useRewardsData(RewardEvents.MAX_REWARD_RATE);
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % 16);
    }, 4800);
    return () => clearInterval(interval);
  }, [isDesktop]);

  const merchantName = useMemo(() => (
    <Typography
      variant="title-h6"
      component="h1"
      noWrap
    >
      {title}
    </Typography>
  ), [title]);

  const rewardMessage = useMemo(() => maxRewardRate && (
    <Stack
      direction="row"
      spacing={0.5}
      alignItems="center"
      sx={{
        backgroundColor: 'success.surface',
        borderRadius: '24px',
        padding: '4px 8px 4px 6px',
      }}
    >
      <Icon name="gift-filled" color="success.dark" />
      <Typography variant="title-sm" color="success.dark" noWrap>
        Earn up to
        {' '}
        {maxRewardRate}
        % cashback
      </Typography>
    </Stack>
  ), [maxRewardRate]);

  if (!rewardMessage) {
    return merchantName;
  }

  return (
    <Stack
      sx={{
        height: 32, width: '100%', position: 'relative',
      }}
      overflow="hidden"
    >
      <Wrapper index={index}>{merchantName}</Wrapper>
      <Wrapper index={index + 1}>{rewardMessage}</Wrapper>
      <Wrapper index={index + 2}>{merchantName}</Wrapper>
      <Wrapper index={index + 3}>{rewardMessage}</Wrapper>
    </Stack>
  );
}
function Wrapper({ children, index }) {
  const realIndex = index % 4;

  return (
    <Box sx={{
      height: 32,
      transition: 'top 0.6s ease-in-out',
      opacity: realIndex === 3 ? 0 : 1,
      top: `${realIndex === 3 ? 32 : realIndex * -32}px`,
      position: 'absolute',
    }}
    >
      {children}
    </Box>
  );
}

export default Title;
